import { createAquirer, createBusinessDescription, createBusinessType, createTerminalModel, createTerminalType, fetchDropdown, getAddress, getBusinessDescription, getBusinessType, getFinalAddress, listAquirer, listTerminalModel, listTerminalType } from "../../../redux/slices/commonDropdownSlice";
import { useApiCall } from "../../common/useApiCall"

export const useDropdownApi = () => {
    const apiCall = useApiCall();


    const fetchDropdownData = (data, onSuccess, onError) => {
        apiCall(fetchDropdown.type, data, onSuccess, onError, false)
    }

    const fetchAddress = (data, onSuccess, onError) => {
        apiCall(getAddress.type, data, onSuccess, onError, false);
    }

    const fetchFinalAddress = (data, onSuccess, onError) => {
        apiCall(getFinalAddress.type, data, onSuccess, onError, false)
    }

    const addBusinessType = (data, onSuccess, onError) => {
        apiCall(createBusinessType.type, data, onSuccess, onError);
    }

    const listBusinessType = (data, onSuccess, onError) => {
        apiCall(getBusinessType.type, data, onSuccess, onError);
    }

    const addBusinessDescription = (data, onSuccess, onError) => {
        apiCall(createBusinessDescription.type, data, onSuccess, onError);
    }

    const listBusinessDescription = (data, onSuccess, onError) => {
        apiCall(getBusinessDescription.type, data, onSuccess, onError);
    }


    const addAquirer = (data, onSuccess, onError) => {
        apiCall(createAquirer.type, data, onSuccess, onError)
    }
    const getAquirer = (data, onSuccess, onError) => {
        apiCall(listAquirer.type, data, onSuccess, onError)
    }

    const addTerminalType = (data, onSuccess, onError) => {
        apiCall(createTerminalType.type, data, onSuccess, onError);
    }
    const getTerminalType = (data, onSuccess, onError) => {
        apiCall(listTerminalType.type, data, onSuccess, onError);
    }

    const addTerminalModel = (data, onSuccess, onError) => {
        apiCall(createTerminalModel.type, data, onSuccess, onError);
    }
    const getTerminalModel = (data, onSuccess, onError) => {
        apiCall(listTerminalModel.type, data, onSuccess, onError);
    }



    return {
        fetchDropdownData,
        fetchAddress,
        fetchFinalAddress,


        addBusinessDescription,
        listBusinessDescription,

        addBusinessType,
        listBusinessType,


        addAquirer,
        getAquirer,
        addTerminalType,
        getTerminalType,
        addTerminalModel,
        getTerminalModel
    }
}